import {
  FETCH_USER_ROLES_FOR_ACCOUNT, FETCH_USER_ROLES_FOR_ACCOUNT_SUCCEEDED, FETCH_USER_ROLES_FOR_ACCOUNT_FAILED,
  FETCH_USER_ROLE, FETCH_USER_ROLE_SUCCEEDED, FETCH_USER_ROLE_FAILED,
  CREATE_USER_ROLE, CREATING_USER_ROLE_SUCCEEDED, CREATING_USER_ROLE_FAILED,
  UPDATE_USER_ROLE, UPDATING_USER_ROLE_SUCCEEDED, UPDATING_USER_ROLE_FAILED,
  DELETE_USER_ROLE, DELETING_USER_ROLE_SUCCEEDED, DELETING_USER_ROLE_FAILED,
  SEARCH_USER_ROLES_FOR_AUTO_COMPLETE, SEARCH_USER_ROLES_FOR_AUTO_COMPLETE_SUCCEEDED, SEARCH_USER_ROLES_FOR_AUTO_COMPLETE_FAILED
} from './actionTypes.jsx';


import axios from 'axios';
import buildUrl from 'build-url-ts';

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const USER_ROLES_BASE_URL = `${apiUrl}/api/2.0/user_roles`;

/*
* CREATE USER ROLES FOR ACCOUNT
*/
export function createUserRole(request) {
  return function (dispatch) {
    dispatch(creatingUserRole());

    return axios({
      method: 'POST',
      url: USER_ROLES_BASE_URL,
      data: request
    })
      .then(response =>
        dispatch(creatingUserRoleSucceeded(response.data))
      )
      .catch(error =>
        dispatch(creatingUserRoleFailed(error))
      )
  }
}

function creatingUserRole() {
  return {
    type: CREATE_USER_ROLE,
    payload: {}
  }
}

function creatingUserRoleSucceeded(response) {
  return {
    type: CREATING_USER_ROLE_SUCCEEDED,
    payload: response
  }
}

function creatingUserRoleFailed(error) {
  return {
    type: CREATING_USER_ROLE_FAILED,
    payload: error
  }
}

/*
* UPDATE USER ROLES FOR ACCOUNT
*/
export function updateUserRole(id, request) {
  return function (dispatch) {
    dispatch(updatingUserRole(id));

    return axios({
      method: 'PUT',
      url: `${USER_ROLES_BASE_URL}/${id}`,
      data: request
    })
      .then(response =>
        dispatch(updatingUserRoleSucceeded(id, response.data))
      )
      .catch(error =>
        dispatch(updatingUserRoleFailed(id, error))
      )
  }
}

function updatingUserRole(id) {
  return {
    type: UPDATE_USER_ROLE,
    payload: {
      id: id
    }
  }
}

function updatingUserRoleSucceeded(id, response) {
  return {
    type: UPDATING_USER_ROLE_SUCCEEDED,
    payload: {
      id: id,
      response: response
    }
  }
}

function updatingUserRoleFailed(id, error) {
  return {
    type: UPDATING_USER_ROLE_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}


/*
* FETCH USER ROLES FOR ACCOUNT
*/
export function fetchUserRolesForAccount() {
  return function (dispatch) {
    dispatch(fetchingAction(FETCH_USER_ROLES_FOR_ACCOUNT));

    return axios({
      method: 'GET',
      url: `${USER_ROLES_BASE_URL}/all`
    })
      .then(response =>
        dispatch(fetchingSucceededAction(FETCH_USER_ROLES_FOR_ACCOUNT_SUCCEEDED, response.data))
      )
      .catch(error =>
        dispatch(fetchingFailedAction(FETCH_USER_ROLES_FOR_ACCOUNT_FAILED, error))
      )
  }
}

/*
* FETCH USER ROLE
*/
export function fetchUserRole(id) {
  return function (dispatch) {
    dispatch(fetchingAction(FETCH_USER_ROLE));


    let url = buildUrl(USER_ROLES_BASE_URL, {
      path: `${id}`
    });

    return axios({
      method: 'GET',
      url: url
    }).then(response =>
        dispatch(fetchingSucceededAction(FETCH_USER_ROLE_SUCCEEDED, response.data))
      )
      .catch(error =>
        dispatch(fetchingFailedAction(FETCH_USER_ROLE_FAILED, error))
      )
  }
}


/*
* DELETE USER ROLE
*/
export function deleteUserRole(id) {
  return function (dispatch) {
    dispatch(fetchingAction(DELETE_USER_ROLE));


    let url = buildUrl(USER_ROLES_BASE_URL, {
      path: `${id}`
    });

    return axios({
      method: 'DELETE',
      url: url
    }).then(response =>
      dispatch(fetchingSucceededAction(DELETING_USER_ROLE_SUCCEEDED, response.data))
    )
      .catch(error =>
        dispatch(fetchingFailedAction(DELETING_USER_ROLE_FAILED, error))
      )
  }
}

/*
* SEARCH USER ROLES FOR AUTO COMPLETE
*/
export function searchUserRolesForAutoComplete(query) {
  return function (dispatch) {
    dispatch(fetchingAction(SEARCH_USER_ROLES_FOR_AUTO_COMPLETE));

    const data = {
      query: query
    }

    return axios({
      method: 'GET',
      url: `${USER_ROLES_BASE_URL}/search`,
      params: data
    })
      .then(response =>
        dispatch(fetchingSucceededAction(SEARCH_USER_ROLES_FOR_AUTO_COMPLETE_SUCCEEDED, response.data))
      )
      .catch(error =>
        dispatch(fetchingFailedAction(SEARCH_USER_ROLES_FOR_AUTO_COMPLETE_FAILED, error))
      )
  }
}

/*
* Common functions
*/
function fetchingAction(type) {
  return {
    type: type,
    payload: {}
  }
}

function fetchingSucceededAction(type, json) {
  return {
    type: type,
    payload: json
  }
}

function fetchingFailedAction(type, error) {
  return {
    type: type,
    payload: error
  }
}